"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationSchema = void 0;
const yup = __importStar(require("yup"));
const notification_type_enum_1 = require("../../enums/notification-type.enum");
const utilities_1 = require("../../utilities");
exports.notificationSchema = yup.object().shape({
    id: yup.string().notRequired(),
    title: yup.string().required(),
    body: yup.string().required(),
    relatedUserId: yup.string().required(),
    actionLink: yup.string().notRequired().nullable(),
    createdAt: yup.number().notRequired().nullable(),
    type: yup.string().oneOf((0, utilities_1.getEnumValues)(notification_type_enum_1.NotificationType)).notRequired().nullable(),
    isAcknowledged: yup.boolean().notRequired().nullable(),
    sender: yup.object().shape({
        id: yup.string().notRequired().nullable(),
        name: yup.string().notRequired(),
        lastName: yup.string().notRequired().nullable(),
    }).notRequired(),
    userList: yup.array().of(yup.object().shape({
        id: yup.string().required(),
        name: yup.string().required(),
        lastName: yup.string().notRequired().nullable(),
    })).notRequired(),
});
